<template>
  <div class="row h-100">
    <div class="col-12 h-100">
      <div class="poppins planned-content no-top-padding h-100">
        <div class="h-100 d-flex flex-column">
          <div class="d-flex justify-content-end">
            <span>
              <b-button variant="primary" size="lg" :disabled="isSaving" @click="onSave">
                <b-spinner v-if="isSaving" small />
                {{ isSaving ? $translate('saving') : $translate('save') }}
              </b-button>
            </span>
          </div>
          <div class="row">
            <div class="col-lg-6 col-sm-6 col-xs-12">
              <Select v-model="selectedYear" :on-change="init" :options="yearOptions" form-group-id="Year" placeholder="year" />
            </div>
          </div>
          <Lines v-if="loaded" :set-modified-data="setModifiedData" :monthly-data="monthlyData" :modified-data="modifiedData" />
          <Loader v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Lines from './lines';

import moment from 'moment';
import api from '../../../api';
import Notification from '../../common/notification';

import Select from '../../common/select';
import Loader from '../../common/loader';

const currentYear = Number(moment().format('YYYY'));

export default {
  title: 'Energiewerte',
  components: { Loader, Select, Lines },
  data() {
    return {
      loaded: false,
      isSaving: false,
      selectedYear: currentYear,
      yearOptions: [],
      monthlyData: {},
      modifiedData: {},
    };
  },
  async created() {
    const yearList = await api.year.get();
    this.yearOptions = yearList.data.map(({ year }) => year);
    this.selectedYear = localStorage.getItem('selectedYear') || currentYear;
    this.init();
  },
  methods: {
    setModifiedData(v, name, numOfMonth) {
      this.modifiedData[numOfMonth][name] = v;
    },
    async init() {
      localStorage.setItem('selectedYear', this.selectedYear);
      this.loaded = false;
      const monthlyData = await api.energieWate.getMonthDataOfRMVA(this.selectedYear);
      const currentEnergieWate = await api.energieWate.getByYear(this.selectedYear);

      if (currentEnergieWate.data) {
        this.modifiedData = currentEnergieWate.data;
      } else {
        const modifiedData = {};
        const monthNameList = moment.monthsShort();
        monthNameList.forEach((name, index) => {
          modifiedData[index + 1] = {
            'Ist Wärmelieferung': null,
            'Ist Strombezug': null,
            'Ist Stromlieferung 110kV': null,
            'Ist Stromlieferung 25kV': null,
          };
        });

        this.modifiedData = modifiedData;
      }

      this.monthlyData = monthlyData.data;

      this.loaded = true;
    },
    async onSave() {
      try {
        this.isSaving = true;
        console.log(this.modifiedData, 'this.modifiedData');
        if (this.modifiedData.year) {
          await api.energieWate.update({
            year: this.selectedYear,
            modifiedData: this.modifiedData,
          });
        } else {
          await api.energieWate.create({
            year: this.selectedYear,
            modifiedData: this.modifiedData,
          });
        }
        Notification({ type: 'success', title: this.$translate('success'), message: this.$translate('success') });
        this.init();
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.planned-content {
  overflow-x: hidden;
}

.no-top-padding {
  padding-top: 0;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
